import { FC, ReactNode } from 'react';

import { Typography } from '@beeline/design-system-react/extracted-styles';

import clsx from 'clsx';

import classes from './Section.module.scss';

export interface SectionProps {
  children?: ReactNode;
  title: ReactNode;
  testId?: string;
  containerClassName?: string;
  contentClassName?: string;
  scrollable?: boolean;
}

export const Section: FC<SectionProps> = ({
  children,
  title,
  testId,
  containerClassName,
  contentClassName,
  scrollable,
}) => {
  return (
    <div
      className={clsx(
        classes.container,
        scrollable && classes.scrollableContainer,
        containerClassName,
      )}
      data-testid={testId ?? 'section'}
    >
      <Typography variant='subtitle2'>{title}</Typography>
      {children && (
        <div className={clsx(classes.content, contentClassName)}>
          {children}
        </div>
      )}
    </div>
  );
};
